<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }" [template]="customLoadingTemplate"></ngx-loading>
<ng-template #customLoadingTemplate></ng-template>
<div class="app-content content">
	<div class="content-wrapper">
		<div class="content-detached">
			<div class="content-body">
				<app-search-bar [config]="configLocal.barraBusqueda" [criterioPrincipal]="configLocal.barraBusqueda.criterioPrincipal" [registroActivacion]="true" [useAccordionMode]="true" [useInlineDeactivatedCheckbox]="true" [useInlineSearchButton]="true" [filtroEmisor]="true" [mostrarListaCompletaEmisores]="true" [listaCompletaEmisores]="emisoresSource" [emisorBusquedaDefault]="this.filter.emisorId" (busqueda)="searchElementsByFilter($event)"> </app-search-bar>
				<div class="row">
					<div class="col-12">
						<div class="card card-custom">
							<div class="card-header">
								<h4 class="card-title">Mantenedor Alertas</h4>
							</div>
							<div class="card-content">
								<div class="card-body">
									<ngx-datatable
										#table
										class="material mobile-hidden"
										[rows]="rowsMantenedor"
										[columnMode]="'flex'"
										[headerHeight]="50"
										[footerHeight]="50"
										[rowHeight]="70"
										fxFlex="auto"
										[externalPaging]="true"
										[count]="page.totalElements"
										[offset]="page.pageNumber"
										[limit]="page.pageSize"
										(page)="setPage($event)"
										[messages]="{ emptyMessage: 'Sin datos para mostrar' | translate, totalMessage: 'Elementos totales' | translate, selectedMessage: false }"
										[externalSorting]="false"
										[sortType]="SortType.multi">
										<ngx-datatable-column name="nombre" [flexGrow]="5" [sortable]="true" [resizeable]="false">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Nombre</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="text-table-alignment">{{ row.nombre }}</span>
											</ng-template>
										</ngx-datatable-column>

										<ngx-datatable-column name="usuariosAsignados" [flexGrow]="2" [sortable]="true" [resizeable]="false" [cellClass]="'number-table-alignment'" [headerClass]="'number-table-alignment'">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Usuarios Asignados</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="text-table-alignment">{{ row.usuariosAsignados }}</span>
											</ng-template>
										</ngx-datatable-column>

										<ngx-datatable-column name="Acciones" [flexGrow]="2" [sortable]="false" [resizeable]="false">
											<ng-template ngx-datatable-cell-template let-row="row">
												<a class="primary edit mr-1 mrless" ngbTooltip="Configurar Alerta" id="mantenedor-alertas.component_Configurar_Alerta" (click)="openEditAlertModal(editAlertModal, row)" *ngIf="permissions.getPermission('30-110-10').asignado && isSuperAdm && row.configurable">
													<div class="icon-circle bg-primary text-center align-middle pt-info-button">
														<fa-icon icon="cog" class="fa-lg text-white"></fa-icon>
													</div>
												</a>
												<a class="primary edit mr-1 mrless" ngbTooltip="Asignar Usuarios" id="mantenedor-alertas.component_Asignar_Usuarios" (click)="openAlertUserModal(usersModal, row)" *ngIf="permissions.getPermission('30-110-10').asignado">
													<div class="icon-circle bg-primary text-center align-middle pt-info-button">
														<fa-icon icon="id-badge" class="fa-lg text-white"></fa-icon>
													</div>
												</a>
											</ng-template>
										</ngx-datatable-column>
										<ngx-datatable-footer>
											<ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize" let-selectedCount="selectedCount" let-curPage="curPage" let-offset="offset" let-isVisible="isVisible">
												<div class="col-auto">Elementos por página</div>
												<div class="mr-5">
													<ng-select [(ngModel)]="page.pageSize" [items]="page.pageSizes" [clearable]="false" (change)="setPageSize()" dropdownPosition="top" style="overflow: visible" appendTo="datatable-footer">
														<option *ngFor="let option of page.pageSizes" [value]="option"></option>
													</ng-select>
												</div>
												<div class="ml-5 col-auto divisor-footer">
													<div class="page-count">{{ rowCount | number:'1.0-0':'es-CL' }} Elementos totales</div>
												</div>
												<datatable-pager [pagerLeftArrowIcon]="'datatable-icon-left'" [pagerRightArrowIcon]="'datatable-icon-right'" [pagerPreviousIcon]="'datatable-icon-prev'" [pagerNextIcon]="'datatable-icon-skip'" [page]="curPage" [size]="pageSize" [count]="rowCount" [hidden]="!(rowCount / pageSize > 1)" (change)="table.onFooterPage($event)"> </datatable-pager>
											</ng-template>
										</ngx-datatable-footer>
									</ngx-datatable>

									<!-- seccion tabla mobile-->
									<ngx-datatable
										#tableMobile
										*ngIf="componentStarted"
										class="material desktop-hidden"
										[rows]="rowsMantenedor"
										[columnMode]="'flex'"
										[headerHeight]="50"
										[footerHeight]="50"
										[rowHeight]="70"
										fxFlex="auto"
										[externalPaging]="true"
										[count]="page.totalElements"
										[offset]="page.pageNumber"
										[limit]="page.pageSize"
										(page)="setPage($event)"
										[scrollbarH]="true"
										[messages]="{ emptyMessage: 'Sin datos para mostrar' | translate, totalMessage: 'Elementos totales' | translate, selectedMessage: false }">
										<!-- Row Detail Template -->
										<ngx-datatable-row-detail [rowHeight]="70" #myDetailRow>
											<ng-template let-row="row" let-expanded="expanded" ngx-datatable-row-detail-template>
												<div class="text-wrap">Nombre: {{ row.nombre }}</div>
											</ng-template>
										</ngx-datatable-row-detail>
										<ngx-datatable-column [width]="30" [resizeable]="false" [sortable]="false" [draggable]="false" [canAutoResize]="false">
											<ng-template let-row="row" let-expanded="expanded" ngx-datatable-cell-template>
												<a [class.datatable-icon-right]="!expanded" [class.datatable-icon-down]="expanded" title="Expand/Collapse Row" (click)="toggleExpandRow(row)" class="desktop-hidden"> </a>
											</ng-template>
										</ngx-datatable-column>

										<ngx-datatable-column name="Acciones" [flexGrow]="3" [sortable]="false" [resizeable]="false">
											<ng-template ngx-datatable-cell-template let-row="row">
												<a class="primary edit mr-1 mrless" ngbTooltip="Configurar Alerta" id="mantenedor-alertas.component_Configurar_Alerta" (click)="openEditAlertModal(editAlertModal, row)" *ngIf="permissions.getPermission('30-110-10').asignado && isSuperAdm && row.configurable">
													<div class="icon-circle bg-primary text-center align-middle pt-info-button">
														<fa-icon icon="cog" class="fa-lg text-white"></fa-icon>
													</div>
												</a>
												<a class="primary edit mr-1 mrless" ngbTooltip="Asignar usuarios" id="mantenedor-alertas.component_Asignar_usuarios" (click)="openAlertUserModal(usersModal, row)" *ngIf="permissions.getPermission('30-110-10').asignado">
													<div class="icon-circle bg-primary text-center align-middle pt-info-button">
														<fa-icon icon="id-badge" class="fa-lg text-white"></fa-icon>
													</div>
												</a>
											</ng-template>
										</ngx-datatable-column>

										<ngx-datatable-footer>
											<ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize" let-selectedCount="selectedCount" let-curPage="curPage" let-offset="offset" let-isVisible="isVisible">
												<div class="col-2 pl-0">Elementos por página</div>
												<div>
													<ng-select [(ngModel)]="page.pageSize" [items]="page.pageSizes" [clearable]="false" (change)="setPageSize()" dropdownPosition="top" style="overflow: visible" appendTo="datatable-footer">
														<option *ngFor="let option of page.pageSizes" [value]="option"></option>
													</ng-select>
												</div>
												<div class="ml-2 pl-1 pr-0 col-3 divisor-footer">
													<div class="page-count">{{ rowCount | number:'1.0-0':'es-CL' }} Elementos</div>
												</div>
												<datatable-pager [pagerLeftArrowIcon]="'datatable-icon-left'" [pagerRightArrowIcon]="'datatable-icon-right'" [pagerPreviousIcon]="'datatable-icon-prev'" [pagerNextIcon]="'datatable-icon-skip'" [page]="curPage" [size]="pageSize" [count]="rowCount" [hidden]="!(rowCount / pageSize > 1)" (change)="tableMobile.onFooterPage($event)"> </datatable-pager>
											</ng-template>
										</ngx-datatable-footer>
									</ngx-datatable>
									<!-- fin seccion tabla mobile-->
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<ng-template #usersModal let-d="dismiss">
	<div class="modal-content">
		<div class="modal-header">
			<div>
				<h5 class="modal-title" id="exampleModalLabel1">{{ alertToEdit.nombre }}</h5>
				<p class="text-muted mb-0" style="font-size: 0.875rem; margin-top: 0.5rem;">{{ getAlertaDescripcion(alertToEdit.alertaId) }}</p>
			</div>

			<button class="btn btn-warning float-right mr-5 mt-5" (click)="findUserModal(FindUsersModal)" *ngIf="permissions.getPermission('30-110-14').asignado">
				<i class="flaticon-search"></i>
				Asignar Usuarios
			</button>
		</div>
		<div class="heading-elements mt-0"></div>
		<div class="modal-body">
			<h4>Usuarios Asignados</h4>

			<form (ngSubmit)="updateAlertUsers(EditForm)" #EditForm="ngForm">
				<div class="modal-body">
					<div class="form-group row mx-auto" style="align-items: baseline">
						<table class="table table-bordered">
							<thead>
								<tr>
									<th>Rut</th>
									<th>Nombre</th>
									<th>Correo</th>
									<th>Acciones</th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let item of alertToEdit.usuarios">
									<td>
										{{ item.rutFormateado }}
									</td>
									<td>{{ item.nombre }} {{ item.apellidos }}</td>
									<td>
										{{ item.email }}
									</td>
									<td>
										<a [routerLink]="" ngbTooltip="Quitar Usuario" class="primary edit mr-1 mrless" id="mantenedor-alertas.component_Quitar_Usuario" (click)="deleteAlertUsers(item)">
											<div class="icon-circle bg-danger text-center align-middle pt-info-button">
												<fa-icon icon="times-circle" class="fa-lg text-white"></fa-icon>
											</div>
										</a>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div class="modal-footer">
					<alert id="alert-errormodal"></alert>
					<div class="form-group position-relative has-icon-left mb-0">
						<button *ngIf="permissions.getPermission('30-110-12').asignado" type="submit" id="add-contact-item" class="btn btn-info add-contact-item">
							<i class="la la-paper-plane-o d-lg-none"></i>
							<span class="d-none d-lg-block">Guardar</span>
						</button>
					</div>
					<div class="form-group position-relative has-icon-left mb-0">
						<button type="button" class="btn btn-success" data-dismiss="modal" (click)="closeAlertUsersModal()">Volver</button>
					</div>
				</div>
			</form>
		</div>
	</div>
</ng-template>

<ng-template #FindUsersModal let-d="dismiss">
	<div class="modal-content">
		<div class="modal-header">
			<h5 class="modal-title" id="exampleModalLabel1">Selecciona un usuario para asignar a la alerta {{ alertToEdit.nombre }}</h5>
		</div>
		<div class="modal-body">
			<div class="heading-elements mt-0">
				<app-search-bar [criterioPrincipal]="configLocalUser.barraBusqueda.criterioPrincipal" [config]="configLocalUser.barraBusqueda" (busqueda)="searchElementsByUserFilter($event)" [insideModal]="true"></app-search-bar>
				<ngx-datatable #tableUser class="material" [rows]="rowsMantenedorUser" [columnMode]="'flex'" [rowHeight]="50" [columnMode]="'flex'" [headerHeight]="50" [footerHeight]="50" fxFlex="auto" [externalPaging]="true" [count]="pageUser.totalElements" [offset]="pageUser.pageNumber" [limit]="pageUser.pageSize" (page)="setPageUser($event)" [messages]="{ emptyMessage: 'Sin datos' | translate, totalMessage: 'Elementos' | translate, selectedMessage: false }">
					<ngx-datatable-column [width]="40" [sortable]="false" [canAutoResize]="false" [draggable]="false" [resizeable]="false"> </ngx-datatable-column>

					<ngx-datatable-column name="rut" [flexGrow]="1.5" [sortable]="false" [resizeable]="false">
						<ng-template let-column="column" ngx-datatable-header-template>
							<span class="text-table-alignment">Rut</span>
						</ng-template>
						<ng-template ngx-datatable-cell-template let-row="row"
							><span class="text-table-alignment">{{ row.rutFormateado }} </span></ng-template
						>
					</ngx-datatable-column>
					<ngx-datatable-column name="nombre" [flexGrow]="3" [sortable]="false" [resizeable]="false">
						<ng-template let-column="column" ngx-datatable-header-template>
							<span class="text-table-alignment">Nombre</span>
						</ng-template>
						<ng-template ngx-datatable-cell-template let-row="row"
							><span class="text-table-alignment">{{ row.nombre }} {{ row.apellidos }} </span></ng-template
						>
					</ngx-datatable-column>
					<ngx-datatable-column name="correo" [flexGrow]="3" [sortable]="false" [resizeable]="false">
						<ng-template let-column="column" ngx-datatable-header-template>
							<span class="text-table-alignment">Correo</span>
						</ng-template>
						<ng-template ngx-datatable-cell-template let-row="row"
							><span class="text-table-alignment">{{ row.email }}</span></ng-template
						>
					</ngx-datatable-column>

					<ngx-datatable-column name="Acciones" [flexGrow]="1" [sortable]="false" [resizeable]="false">
						<ng-template ngx-datatable-cell-template let-row="row">
							<a [routerLink]="" ngbTooltip="Asignar Usuario" class="primary edit mr-1 mrless" id="mantenedor-alertas.component_Asignar_Usuario" (click)="addAlertUser(row)">
								<div class="icon-circle bg-success text-center align-middle pt-info-button">
									<fa-icon icon="plus-circle" class="fa-lg text-white"></fa-icon>
								</div>
							</a>
						</ng-template>
					</ngx-datatable-column>
					<ngx-datatable-footer>
						<ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize" let-selectedCount="selectedCount" let-curPage="curPage" let-offset="offset" let-isVisible="isVisible">
							<div class="col-auto">Elementos por página</div>
							<div class="mr-0">
								<ng-select [(ngModel)]="pageUser.pageSize" [items]="pageUser.pageSizes" [clearable]="false" (change)="setUserPageSize()" appendTo=".modal-body datatable-footer" style="overflow: visible; z-index: 1051">
									<option *ngFor="let option of pageUser.pageSizes" [value]="option"></option>
								</ng-select>
							</div>
							<div class="ml-0 col-auto divisor-footer">
								<div class="page-count">{{ rowCount | number:'1.0-0':'es-CL' }} Elementos totales</div>
							</div>
							<datatable-pager [pagerLeftArrowIcon]="'datatable-icon-left'" [pagerRightArrowIcon]="'datatable-icon-right'" [pagerPreviousIcon]="'datatable-icon-prev'" [pagerNextIcon]="'datatable-icon-skip'" [page]="curPage" [size]="pageSize" [count]="rowCount" [hidden]="!(rowCount / pageSize > 1)" (change)="tableUser.onFooterPage($event)"> </datatable-pager>
						</ng-template>
					</ngx-datatable-footer>
				</ngx-datatable>
				<div class="modal-footer">
					<alert id="alert-errormodal"></alert>

					<div class="form-group position-relative has-icon-left mb-0">
						<button type="button" class="btn btn-success" data-dismiss="modal" (click)="d('Cross click')">Volver</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</ng-template>

<ng-template #editAlertModal let-d="dismiss" let-c="close">
	<div class="modal-lg">
		<div class="modal-header">
			<div class="modal-wizard-label">
				<div class="modal-wizard-title">Edición de Alerta</div>
				<div class="modal-wizard-desc">Edite los datos de la alerta actual</div>
			</div>
			<button type="button" class="close" aria-label="Close" (click)="closeEditAlertModal()">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
		<app-alerta-entry [alertToEdit]="selectedAlert" (sendAlertRequest)="editAlertRequest($event)" (sendCloseRequestEmitter)="closeEditAlertModal()"></app-alerta-entry>
	</div>
</ng-template>
